import {fabric} from 'fabric'
//划分标段页面canvas初始化
function canvasInit(setArr,areaArr,changeArr,color){
    let canvas = document.getElementById("myCanvas")
    let ctx = canvas.getContext('2d');
    let heightValue = canvas.height
    let step = 1
    canvas.onwheel = function(e){
        let offX = e.offsetX
        let offY = e.offsetY
        canvas.height = heightValue
        
        let scale = e.deltaY/100
        if(step >= 1){
            step = getFloat(step + (-scale)*0.01,2)
        }else{
            step = 1
        } 
        scale = scale > 0 ? step : step
        ctx.translate(-offX*(step-1),-offY*(step-1))
        ctx.scale(scale,scale) 
        setGrid(color)
        setRoad(setArr)
        setPointArea(areaArr)
        setPointers(changeArr)
    }
}
//道路详情页面canvas初始化
function canvasInit_1(setArr,color){
    let canvas = document.getElementById("myCanvas")
    let ctx = canvas.getContext('2d');
    
    let heightValue = canvas.height
    let step = 1
    canvas.onwheel = function(e){
        let offX = e.offsetX
        let offY = e.offsetY
        canvas.height = heightValue
        
        let scale = e.deltaY/100
        if(step >= 1){
            step = getFloat(step + (-scale)*0.01,2)
        }else{
            step = 1
        }
        scale = scale > 0 ? step : step
        ctx.translate(-offX*(step-1),-offY*(step-1))
        ctx.scale(scale,scale) 
        setGrid(color)
        setRoad(setArr)
        e.preventDefault()
    }
}


// 道路数据连线
function setRoad(setArr){
    console.log(setArr)
    let canvas = document.getElementById("myCanvas")
    let ctx = canvas.getContext('2d');
    
    for(let i=0;i<setArr.length-1;i++){
        //console.log(i)
        ctx.beginPath();
        ctx.strokeStyle = "#FF0000"
        ctx.font = '8px'
        let getArr = setArr[i]
        for(let j=0;j<getArr.length;j++){
            if(j == 0){  
                ctx.moveTo(getArr[j][0],getArr[j][1])
            }else{
                ctx.lineTo(getArr[j][0],getArr[j][1])
            } 
            if(i == 1 && j%20 == 0){
                ctx.fillStyle="#ff0000"
                ctx.fillText(setArr[3][j],getArr[j][0],getArr[j][1]+30)
            }
        }
        ctx.closePath();
        ctx.stroke();
    }
}
//散点数据连线
function setPointAreab(canvas,arr){
    let areaPath = 'M'+' '+arr[0][0]+' '+arr[0][1]
    for(let i=1;i<arr.length;i++){
        areaPath += ' '+'L'+' '+arr[i][0]+' '+arr[i][1]
    }
    areaPath = areaPath + 'z'
    canvas.add(new fabric.Path(areaPath,{
        strokeWidth: 0,
        stroke: 'RGB(21,25,255)',
        // fill: 'RGBA(132,132,198,0.3)',
        fill: 'RGBA(213,255,255,0.5)',
        strokeDashArray: [1,1],
        selectable: false,
        hasBorders: false,
        hasControls: false,
    }))
}
function setPointArea(arr){
    let canvas = document.getElementById("myCanvas")
    let ctx = canvas.getContext('2d');
    //绘制区域
    ctx.beginPath();
    ctx.strokeStyle = "RGB(21,25,255)"
    for(let i=0;i<arr.length;i++){
        if(i == 0){  
            ctx.moveTo(arr[i][0],arr[i][1])
        }else{
            ctx.lineTo(arr[i][0],arr[i][1])
        } 
    }
    ctx.fillStyle = "RGBA(213,255,255,0.5)"
    ctx.fill()
    ctx.closePath();
    ctx.stroke();
}
//散点数据画点
function setPointersb(canvas,arr){
    for(let i=0;i<arr.length;i++){
        let textV = 'p'+(i+1)


        // ctx.beginPath();
        // ctx.fillStyle = "#000000";
        // ctx.font = '8px'
        // let textV = 'p'+(i+1)
        // ctx.fillText(textV, arr[i][0],arr[i][1]+ 15);
        // ctx.arc(arr[i][0],arr[i][1], 5, 0, Math.PI * 2, true);
        // ctx.fill()
        // ctx.closePath();
        // ctx.stroke();

        canvas.add(new fabric.Circle({
            radius: 3,
            fill: '#E96B5A',
            stroke: '#E96B5A',
            strokeWidth: 1,
            left: arr[i][0],
            top: arr[i][1],
            originX: 'center', 
            originY: 'center',
            selectable: false,
            hasBorders: false,
            hasControls: false,
        }))
        canvas.add(new fabric.Text(textV,{
            fontSize: 8, 
            left: arr[i][0],
            top: arr[i][1]+15,
            fontFamily: "YAHEI", 
            selectable: false,
            hasBorders: false,
            hasControls: false,
        }))
    }
}
function setPointers(arr){
    //console.log(arr)
    let canvas = document.getElementById("myCanvas")
    let ctx = canvas.getContext('2d');
    for(let i=0;i<arr.length;i++){
        ctx.beginPath();
        ctx.fillStyle = "#000000";
        ctx.font = '8px'
        let textV = 'p'+(i+1)
        ctx.fillText(textV, arr[i][0],arr[i][1]+ 15);
        ctx.arc(arr[i][0],arr[i][1], 5, 0, Math.PI * 2, true);
        ctx.fill()
        ctx.closePath();
        ctx.stroke();
    }
    
    
}

//画栅格
function setGrid(){
    //console.log(color)
    // let colorValue = color ? color : 'RGB(224,224,225)'
    let myCanvas = document.getElementById('myCanvas');
    let ctx = myCanvas.getContext('2d');
    // let heightValue = myCanvas.height
    // myCanvas.height = heightValue
    let gridSize = 50;
    let canvasWidth = ctx.canvas.width;
    let canvasHeight = ctx.canvas.height;

    let xLineTotal = Math.floor(canvasHeight / gridSize);
    let yLineTotal = Math.floor(canvasWidth / gridSize);
    ctx.fillStyle = 'RGBA(204,204,204, 1)';
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);
    ctx.stroke();

    for (let i = 0; i <= xLineTotal; i++) {
        ctx.beginPath();
        ctx.moveTo(0, i * gridSize - 0.5);
        ctx.lineTo(canvasWidth, i * gridSize - 0.5);
        ctx.strokeStyle = '#D8D6D4';
        ctx.stroke();
    }

    for (let i = 0; i <= yLineTotal; i++) {
        ctx.beginPath();
        ctx.moveTo(i * gridSize - 0.5, 0);
        ctx.lineTo(i * gridSize - 0.5, canvasHeight);
        ctx.strokeStyle = '#D8D6D4';
        ctx.stroke();
    }
}

function getFloat (number, n){
    n = n ? parseInt(n) : 0; 
    if (n <= 0) return Math.round(number); 
    number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n); 
    return number; 
}


export {
    setRoad,
    canvasInit,
    canvasInit_1,
    setGrid,
    setPointArea,
    setPointers,
    setPointAreab,
    setPointersb
}